<template>
    <v-form ref="form" class="form-container" lazy-validation>

        <v-text-field
            v-model="alias"
            label="Alias"
            class="form-field"
            required
        />

        <v-text-field
            v-model="originator"
            label="Originator"
            :rules="[
                v => !!v || 'Field Required',
                v => (v.length >= 3) || 'Maximum 3 characters allowed',
                v => (v.length <= 11) || 'Maximum 11 characters allowed',
            ]"
            class="form-field"
            required
        />
        <v-checkbox
            v-model="smsFallbackCheck"
            class="form-field"
            label="Check to enable SMS Fallback"
        />
        <v-checkbox
            v-if="hasPrivilege(PRIVILEGES.CREATE_SHORTLINKS, privileges)"
            v-model="shortlinksCheck"
            class="form-field"
            label="Check to enable Shortlinks (Personalized Campaigns)"
        />
        <v-text-field
            v-model="buttonText"
            label="Button Text (max 30 characters): Optional field - Mandatory for Promotional Campaigns"
            :rules="[
                v => (v.length <= 30) || 'Maximum 30 characters allowed'
            ]"
            class="form-field"
            required
        />
        <v-text-field
            v-model="buttonUrl"
            label="Button URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <v-text-field
            v-model="imageUrl"
            label="Image URL: Optional field - Mandatory for Promotional Campaigns"
            class="form-field"
            required
        />
        <div class="form-field my-2">
            <v-slider
                v-model="selectedSeconds"
                :min="0"
                :max="24 * 60 * 60"
                :step="30"
                :tick-size="30"
                :label="ttlLabel(hours, minutes, remainingSeconds)"
                class="custom-slider"
                :thumb-size="100"
                :rules="[
                    v => selectedSeconds > 0 || 'Time To Live cannot be zero (0)'
                ]"
            >
                <template v-slot:thumb-label>
                    {{ hours }} : {{ minutes }} : {{ remainingSeconds }} Hours
                </template>
            </v-slider>
        </div>
        <create-form-actions needs-padding @next-step="emitNextStep" @cancel="emitCancel" @reset="emitReset" />
    </v-form>
</template>

<script>
    import dateTimeUtils from '@/utils/date-time-utils'
    import moment from 'moment'
    import { PRIVILEGES } from '@/utils/consts'
    import { hasPrivilege } from '@/utils/userUtils'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'

    export default {
        components: { CreateFormActions },
        data() {
            return {
                smsFallbackCheck: false,
                shortlinksCheck: false,
                originator: '',
                datetime: null,
                buttonUrl: '',
                buttonText: '',
                imageUrl: '',
                alias: '',
                modal: false,
                active: false,
                selectedSeconds: 0,
                timeInSeconds: 0,
                columnCount: 0
            }
        },
        computed: {
            privileges() {
                return this.$store.getters.getCurrentUserPrivileges
            },
            PRIVILEGES() {
                return PRIVILEGES
            },
            hours() {
                return Math.floor(this.selectedSeconds / 3600)
            },
            minutes() {
                return Math.floor((this.selectedSeconds % 3600) / 60)
            },
            remainingSeconds() {
                return this.selectedSeconds % 60
            },
            isViberCampaign() {
                return this.$route.name === 'Viber Create Campaign'
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.smsFallbackCheck = false
                this.shortlinksCheck = false
                this.originator = ''
                this.datetime = null
                this.buttonUrl = ''
                this.buttonText = ''
                this.imageUrl = ''
                this.alias = ''
                this.modal = false
                this.active = false
                this.selectedSeconds = 0
                this.timeInSeconds = 0
                this.columnCount = 0
            })
            this.alias = 'CM_VIBER_' + dateTimeUtils.getHumanizedDate(new Date())
            this.datetime = moment().add(2, 'hours').toDate()
        },
        methods: {
            hasPrivilege,
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    originator: this.originator,
                    fallback: this.smsFallbackCheck,
                    alias: this.alias,
                    ttl: this.selectedSeconds,
                    params: 5,
                    buttonUrl: this.buttonUrl,
                    imageUrl: this.imageUrl,
                    buttonCaption: this.buttonText,
                    shortlink: this.shortlinksCheck
                }
                this.$store.dispatch('setRecurringViberCampaign', campaign)
                this.$emit('next-step')
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            emitCancel() {
                this.$emit('cancel')
            },
            emitReset() {
                this.$emit('reset')
            },
            ttlLabel(hours, minutes, remainingSeconds) {
                return dateTimeUtils.ttlLabel(hours, minutes, remainingSeconds)
            },
            getPastDates(date) {
                return dateTimeUtils.getPastDates(date)
            },
            getPastTime(date) {
                return dateTimeUtils.getPastTime(date)
            }
        }
    }
</script>

<style>
.custom-slider .v-slider__thumb-label {
    text-align: center;
}
</style>

<style scoped>

.form-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
